import React, {useEffect, useReducer, useState} from "react";
import { Button } from "react-bootstrap";
import "./RevenueReport.css"
import moment from "moment";
import { connect } from "react-redux";
import AxiosConfig from "src/utilities/AxiosConfig";
import axios from "axios";
import { json } from "stream/consumers";
import { qsStringify } from "src/utilities/helper";
import Loader from "src/components/common/Loader";
import ReportDisplay from "src/components/css/Quickbooks/ReportDisplay";
import {DatabaseInvoiceData, ReportData, ReportRet} from "src/components/css/Quickbooks/ReportDisplayTypes";
import InvoiceReportDisplay from "src/components/css/Quickbooks/InvoiceReportDisplay";
import RevenueSidebySideDisplay from "src/components/css/Quickbooks/RevenueSideBySideDisplay";
import logger from '../../../utilities/logging';
import Checkbox from "src/components/common/checkbox";

//basic object to create a revenue report request in the api
interface RevenueReport{
    session: string
    employeeID: number
    TaskName: string
    CustomerNames: string[]
    fromDate: string
    toDate: string
}
function RevenueReport(props: any){
    const monthSet = [
        {month: "January", value: 0},
        {month: "February", value: 1},
        {month: "March", value: 2},
        {month: "April", value: 3},
        {month: "May", value: 4},
        {month: "June", value: 5},
        {month: "July", value: 6},
        {month: "August", value: 7},
        {month: "September", value: 8},
        {month: "October", value: 9},
        {month: "November", value: 10},
        {month: "December", value: 11}
    ]
    //constant to reference whenever you need the current date
    const today = new Date()
    const [month, setMonth] = useState(today.getMonth())
    const [sideBySideMonth, setSideBySideMonth] = useState(today.getMonth())
    const [year, setYear] = useState<number>(today.getFullYear())
    const [sideBySideYear, setSideBySideYear] = useState(today.getFullYear())
    //date range that the reports will pull from 
    const [toDate, setToDate] = useState(today.toISOString().split('T')[0])
    const [fromDate, setFromDate] = useState(today.toISOString().split('T')[0])
    //Object to be sent to the api when making a report request
    const [RevenueReport, setRevenueReport] = useState<RevenueReport>()
    //Boolean used for displaying a loading screen
    const [isLoading, setIsLoading] = useState(false)
    //Accrual report data from the quickbooks company file
    const [data, setData] = useState<ReportRet>({} as ReportRet)
    //Cash report data from the quickbooks company file
    const [cashData, setCashData] = useState<ReportRet>({} as ReportRet)
    //sets which type of table the user will see on the page
    const [tab, setTab] = useState("Side-by-Side")
    const [minorTab, setMinorTab] = useState("Accrual")
    //Report data from our database
    const [database, setDatabase] = useState<DatabaseInvoiceData[]>([])
    const [Mismatch, setMismatch] = useState(true)
    //function to find the correct from and to date of a given month and year
    const TimeSet = (int: number, year: number) => {
        //start with today's date
        var date = today
        //then set the date to midnight of the first on the given month and year
        date.setDate(1)
        date.setMonth(int)
        date.setHours(0,0,0,0)
        date.setFullYear(year)
        //then find the nearest Friday on or after that date and assign that date to the from date
        date.setDate(date.getDate() - ((2 + date.getDay()) % 7))
        setFromDate(date.toISOString().split('T')[0])
        //now set the year back to the given year in case month was in january
        date.setFullYear(year)
        //set the date to the last day of the month given
        date.setDate(1)
        date.setMonth(int +1)
        date.setDate(date.getDate()-1)
        //Finally set the date to the nearest thursday on or after the current date and assign that to the to date
        date.setDate(date.getDate()-((3 + date.getDay()) % 7))
        setToDate(date.toISOString().split('T')[0])
    }
    //initialize correct values on page load
    useEffect(() => {
        TimeSet(today.getMonth(), today.getFullYear())
    }, [])

    //update report request object when the from and to date are updated
    useEffect(() =>{
        var report = {
            session: AxiosConfig.sessionKeyValue(),
            employeeID: props.userid,
            TaskName: "RevenueReport",
            toDate: toDate,
            fromDate: fromDate,
            CustomerNames: []
        } 
        setRevenueReport(report)
    }, [fromDate, toDate])

    //get quickbooks cash, quickbooks accrual, and database invoice reports from the database
    const FeatchReport = () => {
        //zero out values in case of error
        setData({} as ReportRet)
        setDatabase([] as DatabaseInvoiceData[])
        setCashData({} as ReportRet)
        //set month and year for side by side report
        setSideBySideMonth(month)
        setSideBySideYear(year)
        //initialize axios calls for cash and accrual reports
        axios.post(process.env.REACT_APP_API_URL+`/api/ELMQB/RevenueReport/`, qsStringify({...RevenueReport}), AxiosConfig.configValue())
        .then(res => {

            if(res.data.qb){
                try{
                    //get data from accrual report
                    var data = JSON.parse(res.data.qb[0])
                }
                catch(e){
                    //alert if request timed out
                    if(res.data.qb[0] === "wait"){
                        alert("Web service is busy, try again later")
                    }
                    //alert other error
                    else{
                        alert(res.data.qb[0])
                        logger.Error({
                            EventMessage: `Revenue Report -> FetchReport -> Error : ${JSON.stringify(res.data.qb[0])}`,
                            EventCategory: "httprequest"
                        });
                    }
                    setIsLoading(false)
                    return
                }
                try{
                    //get data from cash report
                    var cash = JSON.parse(res.data.qb[1])
                }
                catch(e){
                    //alert if request timed out
                    if(res.data.qb[1] === "wait"){
                        alert("Web service is busy, try again later")
                    }
                    //alert other error
                    else{
                        alert(res.data.qb[1])
                        logger.Error({
                            EventMessage: `Revenue Report -> FetchReport -> Error : ${JSON.stringify(res.data.qb[1])}`,
                            EventCategory: "httprequest"
                        });
                    }
                    setIsLoading(false)
                    return
                }
            }
            else{
                alert(res.data)
                setIsLoading(false)
                return
            }
            //get database data from call
            setIsLoading(false)
            setData(data as ReportRet)
            setCashData(cash as ReportRet)
            var database = res.data.data
            setDatabase(database as DatabaseInvoiceData[])
        })
        .catch(error => {
            alert("There was an error getting Quickbooks reports");
            //console.log(error);
            logger.Error({
                EventMessage: `Revenue Report -> FetchReport -> Error : ${JSON.stringify(error)}`,
                EventCategory: "httprequest"
            });
            AxiosConfig.handleError(error);
            setIsLoading(false)
        })
        setIsLoading(false)
    }
    return(
        <div className="RevenueReport">
            <h1>Report Revenue</h1>
            <div className="RevenueInputs">
                <div>
                    <b>Month  </b>
                    <select onChange={(e) => (TimeSet(Number(e.target.value), year), setMonth(Number(e.target.value)))} value={month}>
                        {
                            monthSet.map(x => (
                                <option value={x.value} key={x.value}>{x.month}</option>
                            ))
                        }
                    </select>
                </div>
                <div>
                    <b>Year </b>
                    <input type="number"  defaultValue={year} pattern="[0-9]*" onChange={(e) => (setYear(Number(e.target.value)), TimeSet(month, Number(e.target.value)))}/>
                </div>
                <Button variant="primary" onClick={() => (FeatchReport(), setIsLoading(true))} disabled={isLoading}>
                    Find Report
                </Button>
            </div>
            <div className="InvoiceCompareTabs">
                <div className={tab === "Quickbooks"? "ClickedInvoiceCompareTab":"InvoiceCompareTab"} onClick={() => setTab("Quickbooks")}>
                    <span>Quickbooks</span>
                </div>
                <div className={tab === "Database"? "ClickedInvoiceCompareTab":"InvoiceCompareTab"} onClick={() => setTab("Database")}>
                    <span>Database</span>
                </div>
                <div className={tab === "Side-by-Side"? "ClickedInvoiceCompareTab":"InvoiceCompareTab"} onClick={() => setTab("Side-by-Side")}>
                    <span>Side-by-Side</span>
                </div>
                {
                    tab === "Side-by-Side"?
                    <div className="QuickbooksCheckbox">
                        <Checkbox isChecked={Mismatch} onChange={() => setMismatch(!Mismatch)} label="Mismatch only"/>              
                    </div>:null
                }
            </div>
            {
                isLoading?
                <div style={{ height: "calc(60vh - 48px)" }} className="w-100 d-flex justify-content-center align-items-center">
                    <Loader title="Loading Report..." />
                </div>
                :
                tab === "Quickbooks" && data.ReportData!=null?
                <div>
                    <div className="InvoiceCompareTabs">
                        <div className={minorTab === "Accrual"? "ClickedInvoiceCompareTab":"InvoiceCompareTab"} onClick={() => setMinorTab("Accrual")}>
                            <span>Accrual</span>
                        </div>
                        <div className={minorTab === "Cash"? "ClickedInvoiceCompareTab":"InvoiceCompareTab"} onClick={() => setMinorTab("Cash")}>
                            <span>Cash</span>
                        </div>
                    </div>
                    {
                        minorTab === "Accrual"?
                        <ReportDisplay ReportData={data} />:
                        <ReportDisplay ReportData={cashData}  />                     
                    }
                </div>
                :
                tab === "Database"?
                <InvoiceReportDisplay data={database}/>
                :
                data.ReportData !== undefined?
                <RevenueSidebySideDisplay 
                    DatabaseData={database} 
                    ReportData={data?.ReportData.DataRow?? []} 
                    Cols={data.ColDesc.map(x => x.ColTitle.value)}
                    cashCols={cashData.ColDesc.map(c => c.ColTitle.value)}
                    CashReport={cashData.ReportData.DataRow??[]}
                    month={sideBySideMonth}
                    year={sideBySideYear}
                    Mismatch={Mismatch}
                />
                : null
            }
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    username: state.user.userName,
    userid: state.user.userId
})

export default connect(mapStateToProps)(RevenueReport)